import React from 'react';
import { Helmet } from 'react-helmet';

function Error_Seo() {
    return (
        <div>
            <Helmet>
                <title>404 | FinestPay</title>
                <meta name="description" content="" />
                <meta property="og:title" content="404 | FinestPay" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/404"/>
            </Helmet>
        </div>
    )
}

export default Error_Seo
